import ModalEditItemSubItem from './components/ModalEditItemSubItem'
import SecurityItem from './components/SecurityItem'
import SecuritySubItem from './components/SecuritySubItem'
import { Card } from 'components'
import { SPACING } from 'utils'
import { IPaginatedEntityGST } from 'services/core/genericEntityGST'
import {
    IGetAllItemsResponse,
    IGetAllSubItensParams,
    IGetAllSubItensResponse
} from 'services/GST/CadastroItensSubitensSeguranca'
import { useGet } from 'hooks'
import { useSecurityItensAndSubItens } from '../../context'

const Search: React.FC = () => {

    const { selectedItem } = useSecurityItensAndSubItens()

    const {
        data: dataItensSeguranca,
        refresh: refreshItemsSeguranca,
        page: pageItensSeguranca,
        rowsPerPage: rowsPerPageItensSeguranca,
        handleChangePage: handleChangePageItensSeguranca,
        handleChangeRowsPerPage: handleChangeRowsPerPageItensSeguranca
    } = useGet<{}, IPaginatedEntityGST<IGetAllItemsResponse[]>>({
        api: 'Gst',
        isPaginated: true,
        params: {
            nmItemSeguranca: JSON.parse(localStorage.getItem('FORM_serach-security-items-form'))?.txItem?.trim().length > 0 ? JSON.parse(localStorage.getItem('FORM_serach-security-items-form'))?.txItem?.trim() : null
        },
        url: 'ItensSeguranca/GetAllPaginated'
    })

    const {
        data: dataSubItensSeguranca,
        refresh: refreshSubItensSeguranca,
        page: pageSubItensSeguranca,
        rowsPerPage: rowsPerPageSubItensSeguranca,
        handleChangeRowsPerPage: handleChangeRowsPerPageSubItensSeguranca,
        handleChangePage: handleChangePageSubItensSeguranca
    } = useGet<
        IGetAllSubItensParams,
        IPaginatedEntityGST<IGetAllSubItensResponse[]>
    >({
        api: 'Gst',
        condition: Boolean(selectedItem?.idItemSeguranca),
        isPaginated: true,
        params: {
            idItemSeguranca: selectedItem?.idItemSeguranca
        },
        url: 'SubitemSeguranca/GetListByIdItemSeguranca'
    })
    return (
        <Card
            marginLeft={SPACING.spacing20}
            marginRight={SPACING.spacing20}
            marginBottom={SPACING.spacing100}
            padding={SPACING.spacing20}
            boxShadow={`0px -1px 32px rgba(50, 50, 71, 0.12), 0px 24px 32px rgba(50, 50, 71, 0.12)`}
            borderRadius={`0px 10px 0px 0px`}
        >
            <SecurityItem
                data={dataItensSeguranca}
                refresh={refreshItemsSeguranca}
                page={pageItensSeguranca}
                rowsPerPage={rowsPerPageItensSeguranca}
                handleChangePage={handleChangePageItensSeguranca}
                handleChangeRowsPerPage={handleChangeRowsPerPageItensSeguranca}
            />
            {selectedItem && (
                <SecuritySubItem
                    data={dataSubItensSeguranca}
                    refresh={refreshSubItensSeguranca}
                    page={pageSubItensSeguranca}
                    rowsPerPage={rowsPerPageSubItensSeguranca}
                    handleChangePage={handleChangePageSubItensSeguranca}
                    handleChangeRowsPerPage={handleChangeRowsPerPageSubItensSeguranca}
                />
            )}
            <ModalEditItemSubItem
                refreshItemsSeguranca={refreshItemsSeguranca}
                refreshSubitensSeguranca={refreshSubItensSeguranca}
            />
        </Card>
    )
}

export default Search